module.exports = __webpack_public_path__ + "static/img/68.49df95cd.png";